import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import { richText } from '../../util/richText';

import { Heading } from '../../components';

import css from './CustomExtendedDataSection.module.css';

const SectionDetails = props => {
  const {
    fieldConfigs,
    pickExtendedDataFields,
    heading,
    className,
    rootClassName,
    renderDetailIcon = null,
    detailsListClassName = null,
    headerAccessory = null,
  } = props;

  const classes = classNames(rootClassName || css.sectionDetails, className);

  if (!fieldConfigs) {
    return null;
  }

  const existingFields = fieldConfigs?.reduce(pickExtendedDataFields, []);

  return existingFields?.length > 0 ? (
    <section className={classes}>
      {heading ? (
        <div className={css.sectionHeadingRow}>
          {headerAccessory}
          <Heading as="h2" rootClassName={css.sectionHeading}>
            <FormattedMessage id={heading} />
          </Heading>
        </div>
      ) : null}
      <ul className={classNames(css.details, detailsListClassName)}>
        {existingFields.map(detail => {
          // Note: currently, we are auto-linking any value of these key-value details.
          // If this behaviour needs to be changed later (e.g. due to a separate "custom link field"),
          // we need to add an extra flag (linkify: true) through getDetailCustomFieldValue function in util/fieldHelpers.js
          const valueContent = richText(detail.value, {
            linkify: true,
          });
          const icon = typeof renderDetailIcon === 'function' ? renderDetailIcon(detail.key) : null;
          return (
            <li key={detail.key} className={css.detailsRow}>
              {icon}
              <span className={css.detailLabel}>{detail.label}</span>
              <span className={css.detailValue}>{valueContent}</span>
            </li>
          );
        })}
      </ul>
    </section>
  ) : null;
};

export default SectionDetails;
